// extracted by mini-css-extract-plugin
export default {"select":"styles_select__7yMZG","select__select":"styles_select__select__TZ7tY"};